import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { toLocalIso, toUtc } from 'common/utils/date-helpers';
import { PURGE } from 'redux-persist';

const START_DATE = new Date();
const END_DATE = new Date();

const initialState = {
  startDate: toUtc(START_DATE).toISOString(),
  endDate: toUtc(END_DATE).toISOString(),
  key: 'selection'
} as const;

const dateRangeSlice = createSlice({
  name: 'dateRange',
  initialState,
  reducers: {
    changeDateRange: (state, { payload }) => {
      state.endDate = payload.endDate;
      state.startDate = payload.startDate;
      state.key = payload.key;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

const selectSelf = (state: RootState) => state.dateRange;

export const getDateRangeAsObjects = createSelector(
  selectSelf,
  (state): DateRangeValue => {
    return {
      startDate: new Date(state.startDate),
      endDate: new Date(state.endDate),
      key: state.key
    };
  }
);

export const selectDateRangeLocalIso = createSelector(
  getDateRangeAsObjects,
  (dateRange): DateRangeLocalIso => ({
    startDate: toLocalIso(dateRange.startDate),
    endDate: toLocalIso(dateRange.endDate)
  })
);

const { actions, reducer } = dateRangeSlice;

export const { changeDateRange } = actions;

export default reducer;

export interface DateRangeState {
  startDate: string;
  endDate: string;
  key: string;
}

export interface DateRangeValue {
  startDate: Date;
  endDate: Date;
  key: string;
}

export interface DateRangeLocalIso {
  startDate: string;
  endDate: string;
}
